import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import QuestionCircleIcon from 'adp-react-icons/lib/fa/question-circle';
import { Button, Textbox, Popover, Alert, Tooltip } from 'adp-react-components';
import {
  loadHttpHeaders,
  loadAjaxBody
} from './../../../components/utils/utils.js';
const Entities = require('html-entities').AllHtmlEntities;
const entities = new Entities();
class ChallengeQna extends React.Component {
  constructor(props) {
    console.log('constructor initialized for QNA');
    super(props);
    this.state = {
      firstQuestion: '',
      secondQuestion: '',
      answer1: '',
      answer2: '',
      val: '',
      submit: 'SUBMIT',
      disabled: false,
      channelSelectedPosition: ''
    };
    this.handleEnterKeyPress=this.handleEnterKeyPress.bind(this);
  }
  onChangeAnswer2(value) {
      this.props.showErrorMessage('');
    this.setState({
      answer2: value
    });
  }

  onChangeAnswer1(value) {
      this.props.showErrorMessage('');
    this.setState({
      answer1: value
    });
  }

  componentWillMount() {
    console.log('this.props.challengeModeHigh:' + this.props.challengeModeHigh);
    fetch(
      context+'/enroll/adpPassword.faces?stepupOtpDevicesAndActivationAjaxForm',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: loadHttpHeaders(),
        body: loadAjaxBody('stepupOtpDevicesAndActivationAjaxForm', '')
      }
    )
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.success == 'false' || data.success == false) {
          if (data.wizard.message == 'true') {
            this.props.showSessionExpired();
            return;
          }
          this.props.showErrorMessage(data.wizard.message);
          return;
        }
        if (data.success == 'true' || data.success == true) {
          console.log('data.challengeMode' + data.challengeMode);
          console.log('???' + (data.challengeMode == 'HIGH') ? true : false);
          this.setState({
            firstQuestion: data.qna.firstQuestion,
            secondQuestion: data.qna.secondQuestion,
            highChallengeMode: data.challengeMode == 'HIGH' ? true : false,
            channelSelectedPosition: data.selectdPosition,
            submit: 'SUBMIT',
            disabled: false
          });
        }
      });
  }
  handleEnterKeyPress(e) {
  if( e.charCode == 13){
    e.preventDefault();

    if(this.isAnswered()){
      this.onSubmit();
    }
  }
}
onSubmit(event) {
    this.props.showErrorMessage('');
    fetch(context+'/enroll/adpPassword.faces?stepupVerifyQnaForm=', {
      method: 'POST',
      credentials: 'same-origin',
      headers: loadHttpHeaders(),
      body: loadAjaxBody(
        'stepupVerifyQnaForm',
        '&answer1=' + this.state.answer1 + '&answer2=' + this.state.answer2
      )
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.success == 'false' || data.success == false) {
          if (data.wizard.message == 'true') {
            this.props.showSessionExpired();
            return;
          }
          this.props.showErrorMessage(data.wizard.message);
          return;
        }
        if (data.success == 'true' || data.success == true) {
          console.log(
            'this.state.channelSelectedPosition:' +
              this.state.channelSelectedPosition
          );
          if (this.state.channelSelectedPosition == 'Q') {
            fetch(context+'/enroll/adpPassword.faces?finalRedirectPage', {
              method: 'POST',
              credentials: 'same-origin',
              headers: loadHttpHeaders(),
              body: loadAjaxBody('finalRedirectPage', '')
            })
              .then(response => {
                return response.text();
              })
              .then(body => {
                window.location.href = context+'/enroll/redirect.faces';
              });
          } else {
            if (
              this.props.deliveryOtpByEmailOnly == true ||
              this.props.deliveryOtpByEmailOnly == 'true'
            ) {
              console.log(
                'this.props.otpByEmailVal:' + this.props.otpByEmailVal
              );
              this.props.fetchDeliveryMethod(this.props.otpByEmailVal);
            }
            this.props.showOtpVerificationCode(true);
          }
        }
      });
  }

  isAnswered() {
    if (this.props.challengeModeHigh == true) {
      return this.state.answer1 != '';
    } else {
      return this.state.answer1 != '' && this.state.answer2 != '';
    }
  }

  render() {
    let isValid = this.isAnswered();
    return (
      <div className="vdl-row login-form">
        <div className="vdl-col-md-12">
          <form className="adp-form">
            <div className="form-group">
              <div className="vdl-row">
                <div className="vdl-col-sm-14 vdl-col-xs-12">
                  <label htmlFor="fristQuestion">
                    {entities.decode(this.state.firstQuestion)}
                  </label>
                </div>
              </div>
              <div className="form-group password">
                <div className="input-group-full">
                  <Textbox
                    autoFocus
                    value={this.state.answer1}
                    type="password"
                    onChange={this.onChangeAnswer1.bind(this)}
                    onKeyPress={this.handleEnterKeyPress.bind(this)}
                  />
                </div>
              </div>
            </div>

            {!this.props.challengeModeHigh ? (
              <div className="form-group">
                <label htmlFor="confirmPassword">
                  {entities.decode(this.state.secondQuestion)}
                </label>
                <div className="input-group-full">
                  <Textbox
                    value={this.state.answer2}
                    type="password"
                    onChange={this.onChangeAnswer2.bind(this)}
                    onKeyPress={this.handleEnterKeyPress.bind(this)}
                  />
                </div>
              </div>
            ) : null}

            <div className="form-group submit vdl-text-xs-center">
              <Button
                className="primary"
                onClick={this.onSubmit.bind(this)}
                disabled={!isValid}>
                {' '}
                {this.props.submit}
              </Button>
            </div>
            {/* form-group submit vdl-text-xs-center */}
          </form>
          {/* adp-form */}
        </div>
        {/* vdl-col-md-12 */}
      </div>
    );
  }
}
export default ChallengeQna;



// WEBPACK FOOTER //
// ./src/scenes/admin-login/stepup/challenge-qna.js